/* eslint-disable prettier/prettier */
import { JSX, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const PublicRoute = ({ children }: { children: JSX.Element }) => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isAcceptInvitationRoute = location.pathname.startsWith('/accept-invitation/');
  const hasJustAcceptedInvitation = sessionStorage.getItem('invitation-accepted') === 'true';

  useEffect(() => {
    if (user && isAcceptInvitationRoute && !hasJustAcceptedInvitation) {
      logout();
      setTimeout(() => {
        window.location.href = location.pathname; 
      }, 100);
    }
  }, [user, isAcceptInvitationRoute, hasJustAcceptedInvitation]);

  useEffect(() => {
    if (hasJustAcceptedInvitation) {
      sessionStorage.removeItem('invitation-accepted');
    }
  }, []);

  return children;
};
